export default function scrollerSponsorsDouble(widgetElName, widgetElOpts, sponsorsTime) {
  const widgetName = widgetElName;
  const widgetOpts = widgetElOpts;
  const $widget = $(`#${widgetName}`);

  const interval = setInterval(function () {
    if ($('body').hasClass('pageIsLoaded')) {
      setTimeout(() => {
        if (widgetElName === 'scroller-sponsors-second') {
          updateSecondSponsorsStructure();
        } else {
          updateFirstSponsorsStructure();
        }

        const pauseBtn = $(`#${widgetElName} .sponsor-controls-container button`);
        pauseBtn.replaceWith('<span class="sponsor-playpause-btn"></span>');
        $(`#${widgetElName} .sponsor-playpause-btn`).on('click', function () {
          $(`#${widgetElName} .sponsorWidgetContainer`).toggleClass('sponsors-paused');
        });
      }, 2000);

      clearInterval(interval);
    }
  }, 800);

  function updateSecondSponsorsStructure() {
    const $secondScrollerContainer = $(`#${widgetElName} .second-scroller-container`);

    $(`#${widgetElName} .sponsorWidgetContainer`).appendTo($secondScrollerContainer);
    $(`#${widgetElName} .sponsorCarouselImageContainer`).addClass('second-container');
    $(`#${widgetElName} #sponsorArrowLeft`).appendTo($secondScrollerContainer);
    $(`#${widgetElName} #sponsorArrowRight`).appendTo($secondScrollerContainer);
  }

  function updateFirstSponsorsStructure() {
    const $majorSponsorTitle = $(`#${widgetElName} #majorSponsorTitleContainer`);
    const $majorSponsorContainer = $(`#${widgetElName} .majorSponsor`);
    const majorSponsorsTitle = $majorSponsorTitle.find('.homepageh1').first().text();

    if ($majorSponsorContainer.length && $majorSponsorTitle.length) {
      $majorSponsorTitle.wrapAll('<div class="major-sponsor-wrapper" id="major-sponsor-wrapper">');
      const $majorSponsorWrapper = $majorSponsorTitle.parent('.major-sponsor-wrapper');

      $majorSponsorContainer.appendTo($majorSponsorWrapper);
      $majorSponsorWrapper.prependTo($(`#${widgetElName}`));

      $majorSponsorTitle
        .find('.homepageh1')
        .replaceWith(`<h2 class="major-sponsor-title homepageh1">${majorSponsorsTitle}</h2>`);
    }

    const $sponsorsTitleContainer = $(`#${widgetElName} #sponsorsTitleContainer`);
    const sponsorsTitleContent = $sponsorsTitleContainer.find('.homepageh1').text();

    $sponsorsTitleContainer
      .find('.homepageh1')
      .replaceWith(`<h2 class="main-sponsors-title homepageh1">${sponsorsTitleContent}</h2>`);

    const $firstScrollerContainer = $(`#${widgetElName} .scroller-container`).first();
    $sponsorsTitleContainer.insertBefore($firstScrollerContainer);

    $(`#${widgetElName} .sponsorWidgetContainer`).appendTo($firstScrollerContainer);
    $(`#${widgetElName} .sponsorCarouselImageContainer`).addClass('default-container');
    $(`#${widgetElName} #sponsorArrowLeft`).appendTo($firstScrollerContainer);
    $(`#${widgetElName} #sponsorArrowRight`).appendTo($firstScrollerContainer);
  }

  return saffire.widgets.sponsors($widget, {
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    timePerSponsor: sponsorsTime,
    bw: false,
    rotate: true,
  });
}
